import { createApp } from 'vue'
import VueFriendlyIframe from 'vue-friendly-iframe';
import App from './App.vue'
import router from './route'
import store from './store'


createApp(App)
.use(VueFriendlyIframe)
.use(router)
.use(store)
.mount('#app')
